import {
  filtrarAtividadePorGrupoParaTenant,
  filtrarGruposAtividadeParaTenant,
} from "./tenantAtividades";

export const ESTADOS_BRASIL = [
  { sigla: "AC", nome: "Acre" },
  { sigla: "AL", nome: "Alagoas" },
  { sigla: "AP", nome: "Amapá" },
  { sigla: "AM", nome: "Amazonas" },
  { sigla: "BA", nome: "Bahia" },
  { sigla: "CE", nome: "Ceará" },
  { sigla: "DF", nome: "Distrito Federal" },
  { sigla: "ES", nome: "Espírito Santo" },
  { sigla: "GO", nome: "Goiás" },
  { sigla: "MA", nome: "Maranhão" },
  { sigla: "MT", nome: "Mato Grosso" },
  { sigla: "MS", nome: "Mato Grosso do Sul" },
  { sigla: "MG", nome: "Minas Gerais" },
  { sigla: "PA", nome: "Pará" },
  { sigla: "PB", nome: "Paraíba" },
  { sigla: "PR", nome: "Paraná" },
  { sigla: "PE", nome: "Pernambuco" },
  { sigla: "PI", nome: "Piauí" },
  { sigla: "RJ", nome: "Rio de Janeiro" },
  { sigla: "RN", nome: "Rio Grande do Norte" },
  { sigla: "RS", nome: "Rio Grande do Sul" },
  { sigla: "RO", nome: "Rondônia" },
  { sigla: "RR", nome: "Roraima" },
  { sigla: "SC", nome: "Santa Catarina" },
  { sigla: "SP", nome: "São Paulo" },
  { sigla: "SE", nome: "Sergipe" },
  { sigla: "TO", nome: "Tocantins" },
];

export const statusColors = {
  0: "#757575",
  1: "#2196F3",
  2: "#FF9800",
  3: "#00BCD4",
  4: "#4CAF50",
  5: "#F44336",
  6: "#009688",
  7: "#9C27B0",
  8: "#FF5722",
  9: "#1565C0",
  10: "#1976D2",
  11: "#B71C1C",
};

export const statusLabels = {
  0: "Aguardando Análise",
  1: "Em Análise",
  2: "Solicitando Informações",
  3: "Aguardando Pagamento",
  4: "Aprovada",
  5: "Rejeitada",
  6: "Licença Emitida",
  7: "Aguardando Aprovação",
  8: "Correção",
  9: "Licença Assinada",
  10: "Pagamento Efetuado",
  11: "Licença Cancelada",
};

export const statusLabelsEnum = {
  AGUARDANDO_ANALISE: 0,
  ANALISTA_ANALISANDO: 1,
  SOLICITANDO_INFORMACOES: 2,
  AGUARDANDO_PAGAMENTO: 3,
  APROVADA: 4,
  REJEITADA: 5,
  LICENCA_EMITIDA: 6,
  AGUARDANDO_APROVACAO: 7,
  CORRECAO: 8,
  LICENCA_ASSINADA: 9,
  PAGAMENTO_EFETUADO: 10,
  LICENCA_CANCELADA: 11,
};

export const STATUS_SOLICITACAO_IMUTAVEIS = [
  statusLabelsEnum.LICENCA_EMITIDA,
  statusLabelsEnum.LICENCA_ASSINADA,
  statusLabelsEnum.LICENCA_CANCELADA,
];

export const isSolicitacaoImutavel = (status) =>
  STATUS_SOLICITACAO_IMUTAVEIS.includes(status);

export const mascaraStatusEmpreendedor = (status) =>
  status === statusLabelsEnum.CORRECAO
    ? statusLabelsEnum.AGUARDANDO_APROVACAO
    : status;

export const modalidadeEnum = [
  { value: 4, label: "Primeira Licença" },
  { value: 0, label: "Renovação" },
  { value: 1, label: "Regularização" },
  { value: 2, label: "Alteração" },
  { value: 3, label: "Cancelamento" },
];

export const empreendimentoStatusLabels = {
  0: "Ativo",
  1: "Inativo",
  2: "Suspenso",
  3: "Cancelado",
};

const GRUPO_ATIVIDADE_OPTIONS_ALL = [
  { value: 0, label: "Agropecuária" },
  { value: 1, label: "Aquicultura" },
  { value: 2, label: "Resíduos Sólidos" },
  { value: 4, label: "Beneficiamento de Minerais" },
  { value: 5, label: "Comércio e Serviços" },
  { value: 6, label: "Construção Civil" },
  { value: 7, label: "Extração de Minerais" },
  { value: 8, label: "Energia" },
  { value: 9, label: "Beneficiamento de Borracha" },
  { value: 10, label: "Beneficiamento de Couros e Peles" },
  { value: 11, label: "Beneficiamento de Fumo" },
  { value: 12, label: "Beneficiamento de Madeira" },
  { value: 13, label: "Material de Transporte" },
  { value: 14, label: "Material Elétrico e Eletrônico" },
  { value: 15, label: "Beneficiamento de Produtos Agrícolas" },
  { value: 16, label: "Papel e Celulose" },
  { value: 17, label: "Alimentos e Bebidas" },
  { value: 18, label: "Matéria Plástica" },
  { value: 19, label: "Indústria Mecânica" },
  { value: 20, label: "Indústria Metalúrgica" },
  { value: 21, label: "Indústria Química" },
  { value: 22, label: "Indústria Têxtil" },
  { value: 23, label: "Indústrias Diversas" },
  { value: 24, label: "Infraestrutura Urbanística" },
  { value: 25, label: "Infraestrutura de Transporte" },
  { value: 26, label: "Saneamento Ambiental" },
  { value: 27, label: "Sistemas de Comunicação" },
  { value: 28, label: "Obras Hídricas" },
  { value: 29, label: "Empreendimentos de Fauna" },
  { value: 30, label: "Empreendimentos Turísticos" },
  { value: 31, label: "Atividades Florestais" },
];

const ATIVIDADE_POR_GRUPO_ALL = {
  0: [
    { value: 0, label: "01.01 - Criação de animais sem abate (Avicultura)" },
    { value: 1, label: "01.01 - Criação de animais sem abate (Suinocultura)" },
    { value: 2, label: "01.01 - Criação de animais sem abate (Bovinocultura e Bubalinocultura)" },
    { value: 3, label: "01.01 - Criação de animais sem abate (Ovinocaprinocultura)" },
    { value: 4, label: "01.02 - Cultivo de plantas medicinais, aromáticas e condimentares" },
    { value: 5, label: "01.03 - Cultivo de flores e plantas ornamentais (com uso de agrotóxico)" },
    { value: 6, label: "01.04 - Cultivo de flores e plantas ornamentais (sem uso de agrotóxico)" },
    { value: 7, label: "01.05 - Projetos Agrícolas de sequeiro (com uso de agrotóxico)" },
    { value: 8, label: "01.06 - Projetos Agrícolas de sequeiro (sem uso de agrotóxico)" },
    { value: 9, label: "01.07 - Projetos de Irrigação (com uso de agrotóxico)" },
    { value: 10, label: "01.08 - Projetos de Irrigação (sem uso de agrotóxico)" },
    { value: 11, label: "01.09 - Registro de estabelecimento comercializador de agrotóxicos" },
    { value: 12, label: "01.10 - Registro de estabelecimento utilizador de agrotóxicos" },
    { value: 13, label: "01.11 - Criação, Manejo, Conservação e Comercialização de Meliponíneos" },
    { value: 14, label: "01.12 - Outras atividades não especificadas anteriormente" },
  ],
  1: [
    { value: 15, label: "02.01 - Aquicultura" },
    { value: 29, label: "02.13 - Outros" },
  ],
  2: [
    { value: 30, label: "03.01 - Coleta e Transporte de Resíduos Classe I - Perigosos" },
    { value: 31, label: "03.02 - Coleta e Transporte de Resíduos de Classe II - Não Perigosos" },
    { value: 32, label: "03.03 - Coleta e Transporte de Resíduos de Serviços de Saúde" },
    { value: 33, label: "03.04 - Coleta e Transporte de Resíduos da Construção Civil" },
    { value: 34, label: "03.05 - Coleta e Transporte de Efluentes Líquidos" },
    { value: 35, label: "03.06 - Transporte de Cargas Perigosas, Produtos Perigosos ou Inflamáveis" },
    { value: 36, label: "03.07 - Armazenamento de Resíduos da Construção Civil" },
    { value: 37, label: "03.08 - Armazenamento de Produtos Perigosos ou Inflamáveis" },
    { value: 38, label: "03.09 - Armazenamento de Resíduos Classe I - Perigosos" },
    { value: 39, label: "03.10 - Armazenamento de Resíduos de Classe II - Não Perigosos" },
    { value: 40, label: "03.11 - Armazenamento de Resíduos de Serviços de Saúde" },
    { value: 41, label: "03.12 - Armazenamento e Distribuição de Produtos Não Perigosos" },
    { value: 42, label: "03.13 - Tratamento de Resíduos da Construção Civil" },
    { value: 43, label: "03.14 - Tratamento de Resíduos Sólidos - Classe II - Não Perigosos" },
    { value: 44, label: "03.15 - Tratamento de Resíduos Sólidos - Classe I - Perigosos" },
    { value: 45, label: "03.16 - Tratamento de Resíduos Sólidos por Compostagem" },
    { value: 46, label: "03.17 - Tratamento de Resíduos Sólidos para Fins de Pesquisa Científica" },
    { value: 47, label: "03.18 - Usina de reciclagem/triagem de resíduos" },
    { value: 48, label: "03.19 - Incineração de Resíduos Sólidos" },
    { value: 49, label: "03.20 - Co-processamento de resíduos" },
    { value: 50, label: "03.21 - Aterro Industrial Landfarming" },
    { value: 51, label: "03.22 - Aterro sanitário" },
    { value: 52, label: "03.23 - Aterro de Resíduos da Construção Civil" },
    { value: 53, label: "03.24 - Disposição de resíduos especiais de agroquímicos e suas embalagens" },
    { value: 54, label: "03.25 - Disposição de resíduos especiais de serviços de saúde e similares" },
    { value: 55, label: "03.26 - Disposição final de resíduos industriais" },
    { value: 56, label: "03.27 - Coleta, Transporte e Armazenamento de Resíduos Sólidos e Produtos" },
    { value: 57, label: "03.28 - Outras atividades não especificadas anteriormente" },
  ],
  4: [
    { value: 72, label: "05.01 - Beneficiamento de gemas" },
    { value: 73, label: "05.02 - Beneficiamento de Calcário" },
    { value: 74, label: "05.03 - Britagem e/ou moagem de rochas, exceto calcário" },
    { value: 75, label: "05.04 - Fabricação de produtos e artefatos cerâmicos" },
    { value: 76, label: "05.05 - Produção de gesso" },
    { value: 77, label: "05.06 - Produção de cimento" },
    { value: 78, label: "05.07 - Beneficiamento de minerais metalíferos" },
    { value: 79, label: "05.08 - Fabricação de artefatos de rochas ornamentais" },
    { value: 80, label: "05.08 - Fabricação de Artefatos de Rochas Ornamentais" },
    { value: 81, label: "05.09 - Outras" },
  ],
  5: [
    { value: 82, label: "06.01 - Armazenamento, fracionamento e distribuição de óleos vegetais, essência e álcool" },
    { value: 83, label: "06.02 - Base de Armazenamento/distribuição de combustíveis e derivados de petróleo" },
    { value: 84, label: "06.03 - Base de Revenda de GLP" },
    { value: 85, label: "06.04 - Lavagem de veículos" },
    { value: 86, label: "06.05 - Postos de Revenda de Combustíveis" },
    { value: 87, label: "06.06 - Postos de Recebimento de Embalagens de Agrotóxicos" },
    { value: 88, label: "06.07 - Transporte Revendedor Retalhista (TRR)" },
    { value: 89, label: "06.08 - Postos de Combustíveis para frota própria" },
    { value: 90, label: "06.09 - Supermercados e Hipermercados" },
    { value: 91, label: "06.10 - Oficina Mecânica com troca de óleo/pintura" },
    { value: 92, label: "06.11 - Shopping Center" },
    { value: 93, label: "06.12 - Panificadoras, restaurantes e pizzarias" },
    { value: 94, label: "06.13 - Lavanderia Convencional sem esgotamento sanitário" },
    { value: 95, label: "06.14 - Lavanderia Industrial/Hospitalar" },
    { value: 96, label: "06.15 - Outras" },
  ],
  6: [
    { value: 97, label: "07.01 - Condomínios e Conjuntos Habitacionais - Sem infraestrutura" },
    { value: 98, label: "07.02 - Condomínios e Conjuntos Habitacionais - Com infraestrutura" },
    { value: 99, label: "07.03 - Autódromos" },
    { value: 100, label: "07.04 - Cemitérios" },
    { value: 101, label: "07.05 - Construção de muro de contenção" },
    { value: 102, label: "07.06 - Distrito e pólo industrial" },
    { value: 103, label: "07.07 - Hipódromos" },
    { value: 104, label: "07.08 - Hospitais" },
    { value: 105, label: "07.09 - Clínicas e congêneres" },
    { value: 106, label: "07.10 - Kartódromo" },
    { value: 107, label: "07.11 - Laboratórios de Análises Clínicas" },
    { value: 108, label: "07.12 - Penitenciárias" },
    { value: 109, label: "07.13 - Aeroportos Nacionais e Internacionais" },
    { value: 110, label: "07.14 - Aeroportos Regionais" },
    { value: 111, label: "07.15 - Dutos, Gasodutos, Oleodutos e Minerodutos" },
    { value: 112, label: "07.16 - Implantação de Tubovias e Transportadoras de Correia" },
    { value: 113, label: "07.17 - Pista de Pouso" },
    { value: 114, label: "07.18 - Portos" },
    { value: 115, label: "07.19 - Terraplanagem" },
    { value: 116, label: "07.20 - Desmembramento do Solo" },
    { value: 117, label: "07.21 - Loteamento" },
    { value: 118, label: "07.22 - Parque de Vaquejada" },
    { value: 119, label: "07.23 - Outras" },
  ],
  7: [
    { value: 120, label: "08.01 - Jazidas de empréstimo" },
    { value: 121, label: "08.02 - Água Mineral - Campo" },
    { value: 122, label: "08.02 - Água Mineral - Poço" },
    { value: 123, label: "08.03 - Extração de areia, argila e saibro" },
    { value: 124, label: "08.04 - Extração de Diatomito" },
    { value: 125, label: "08.05 - Extração de rochas para construção civil" },
    { value: 126, label: "08.06 - Extração de Rochas Ornamentais" },
    { value: 127, label: "08.07 - Extração e beneficiamento de Gemas" },
    { value: 128, label: "08.08 - Extração de Gipsita" },
    { value: 129, label: "08.09 - Extração de minerais metalíferos" },
    { value: 130, label: "08.10 - Extração de pegmatíticos" },
    { value: 131, label: "08.11 - Extração de Laterita" },
    { value: 132, label: "08.12 - Extração de calcário e magnesita" },
    { value: 133, label: "08.13 - Petróleo e Gás Natural - Campo" },
    { value: 134, label: "08.13 - Petróleo e Gás Natural - Poço" },
    { value: 135, label: "08.14 - Extração de sal" },
    { value: 136, label: "08.15 - Extração de quartzo" },
    { value: 137, label: "08.16 - Outras" },
    { value: 138, label: "08.16 - Outras (Pesquisa mineral)" },
  ],
  8: [
    { value: 139, label: "09.01 - Distribuição de energia elétrica - até 15 kV" },
    { value: 140, label: "09.01 - Distribuição de energia elétrica - de 15 a 138 kV" },
    { value: 141, label: "09.02 - Transmissão de energia elétrica - até 138 kV" },
    { value: 142, label: "09.02 - Transmissão de energia elétrica - acima de 138 kV" },
    { value: 143, label: "09.03 - Energia Eólica" },
    { value: 144, label: "09.04 - Pequena Central Hidrelétrica" },
    { value: 145, label: "09.05 - Subestação" },
    { value: 146, label: "09.06 - Cogeração de energia" },
    { value: 147, label: "09.07 - Usina Hidrelétrica" },
    { value: 148, label: "09.08 - Usina Termoelétrica" },
    { value: 149, label: "09.09 - Energia Solar" },
    { value: 150, label: "09.10 - Energia de Biomassa" },
    { value: 151, label: "09.11 - Minigeração Fotovoltaica" },
    { value: 152, label: "09.12 - Hidrogênio Verde - Eletrolisador" },
    { value: 153, label: "09.12 - Hidrogênio Verde - Produção" },
    { value: 154, label: "09.13 - Outras" },
  ],
  9: [
    { value: 155, label: "10.01 - Beneficiamento de borracha natural" },
    { value: 156, label: "10.02 - Fabricação de artefatos de borracha" },
    { value: 157, label: "10.03 - Fabricação e recondicionamento de pneumáticos" },
    { value: 158, label: "10.04 - Recuperação de pneumáticos" },
    { value: 159, label: "10.05 - Outras" },
  ],
  10: [
    { value: 160, label: "11.01 - Acabamento de couros e peles" },
    { value: 161, label: "11.02 - Curtume e preparação de couros e peles" },
    { value: 162, label: "11.03 - Fabricação de artefatos de couros e peles" },
    { value: 163, label: "11.04 - Fabricação de cola animal" },
    { value: 164, label: "11.05 - Secagem e salga de couros e peles" },
    { value: 165, label: "11.06 - Outras" },
  ],
  11: [
    { value: 166, label: "12.01 - Beneficiamento de fumo" },
    { value: 167, label: "12.02 - Fabricação de cigarros/charutos/cigarrilhas" },
    { value: 168, label: "12.03 - Outras" },
  ],
  12: [
    { value: 169, label: "13.01 - Fabricação de artefatos diversos de madeira" },
    { value: 170, label: "13.02 - Fabricação de chapas e placas de madeira" },
    { value: 171, label: "13.03 - Tratamento de madeira" },
    { value: 172, label: "13.04 - Serraria e desdobramento de madeira" },
    { value: 173, label: "13.05 - Produção de carvão vegetal (florestas plantadas)" },
    { value: 174, label: "13.05 - Produção de carvão vegetal - PMFS" },
    { value: 175, label: "13.06 - Outras" },
  ],
  13: [
    { value: 176, label: "14.01 - Carrocerias, tanques e caçambas" },
    { value: 177, label: "14.02 - Peças e acessórios" },
    { value: 178, label: "14.03 - Aeronaves" },
    { value: 179, label: "14.04 - Veículos ferroviários" },
    { value: 180, label: "14.05 - Veículos rodoviários" },
    { value: 181, label: "14.06 - Embarcações" },
    { value: 182, label: "14.07 - Outras" },
  ],
  14: [
    { value: 183, label: "15.01 - Componentes elétricos e eletrônicos" },
    { value: 184, label: "15.02 - Equipamentos elétricos e eletrônicos" },
    { value: 185, label: "15.03 - Componentes eletromecânicos" },
    { value: 186, label: "15.04 - Baterias e acumuladores" },
    { value: 187, label: "15.05 - Recuperação de transformadores" },
    { value: 188, label: "15.06 - Outras" },
  ],
  15: [
    { value: 189, label: "16.01 - Beneficiamento de algodão" },
    { value: 190, label: "16.02 - Beneficiamento de cera de carnaúba" },
    { value: 191, label: "16.03 - Beneficiamento de fibras vegetais" },
    { value: 192, label: "16.04 - Processamento de sementes de algodão" },
    { value: 193, label: "16.05 - Outras" },
  ],
  16: [
    { value: 194, label: "17.01 - Artefatos de papel" },
    { value: 195, label: "17.02 - Celulose e pasta mecânica" },
    { value: 196, label: "17.03 - Papel e papelão" },
    { value: 197, label: "17.04 - Transformação de papel" },
    { value: 198, label: "17.05 - Outras" },
  ],
  17: [
    { value: 199, label: "18.01 - Agroindústria" },
    { value: 200, label: "18.02 - Beneficiamento de sal" },
    { value: 201, label: "18.03 - Água adicionada de sais" },
    { value: 202, label: "18.04 - Bebidas alcoólicas" },
    { value: 203, label: "18.05 - Bebidas não alcoólicas" },
    { value: 204, label: "18.06 - Doces e conservas" },
    { value: 205, label: "18.07 - Fermentos e leveduras" },
    { value: 206, label: "18.08 - Frios e derivados de carne" },
    { value: 207, label: "18.09 - Massas alimentícias" },
    { value: 208, label: "18.10 - Rações para animais" },
    { value: 209, label: "18.11 - Rapadura, açúcar mascavo e melado" },
    { value: 210, label: "18.12 - Vinagre" },
    { value: 211, label: "18.13 - Abatedouros e frigoríficos" },
    { value: 212, label: "18.14 - Pescados e conservas de pescados" },
    { value: 213, label: "18.15 - Laticínios" },
    { value: 214, label: "18.16 - Óleos e gorduras vegetais" },
    { value: 215, label: "18.17 - Açúcar, Álcool e Aguardente" },
    { value: 216, label: "18.18 - Gelo" },
    { value: 217, label: "18.19 - Beneficiamento de produtos agrícolas (geral)" },
    { value: 218, label: "18.19 - Beneficiamento de produtos agrícolas (específico)" },
    { value: 219, label: "18.20 - Outras" },
  ],
  18: [
    { value: 220, label: "19.01 - Fabricação de plástico e artefatos" },
    { value: 221, label: "19.02 - Laminados plásticos" },
    { value: 222, label: "19.03 - Móveis plásticos" },
    { value: 223, label: "19.04 - Espuma plástica" },
    { value: 224, label: "19.05 - Reciclagem de plásticos" },
    { value: 225, label: "19.06 - Outras" },
  ],
  19: [
    { value: 226, label: "20.01 - Com tratamento térmico sem tratamento de superfície" },
    { value: 227, label: "20.01 - Com tratamento térmico com tratamento de superfície" },
    { value: 228, label: "20.01 - Sem tratamento térmico com tratamento de superfície" },
    { value: 229, label: "20.01 - Sem tratamento térmico sem tratamento de superfície" },
    { value: 230, label: "20.02 - Instalações frigoríficas" },
    { value: 231, label: "20.03 - Máquinas de costura" },
    { value: 232, label: "20.04 - Refrigeradores" },
    { value: 233, label: "20.05 - Ventiladores" },
    { value: 234, label: "20.06 - Geradores" },
    { value: 235, label: "20.07 - Metal mecânica" },
    { value: 236, label: "20.08 - Sistemas energéticos" },
    { value: 237, label: "20.09 - Bombas hidráulicas" },
    { value: 238, label: "20.10 - Outros" },
  ],
  20: [
    { value: 239, label: "21.01 - Artefatos de alumínio" },
    { value: 240, label: "21.02 - Autopeças" },
    { value: 241, label: "21.03 - Componentes de aerogeradores" },
    { value: 242, label: "21.04 - Embalagens metálicas" },
    { value: 243, label: "21.05 - Estruturas com tratamento" },
    { value: 244, label: "21.05 - Estruturas sem tratamento" },
    { value: 245, label: "21.06 - Metais preciosos" },
    { value: 246, label: "21.07 - Retificação de peças" },
    { value: 247, label: "21.08 - Metalurgia do pó" },
    { value: 248, label: "21.09 - Metais não ferrosos" },
    { value: 249, label: "21.10 - Fundidos com tratamento" },
    { value: 250, label: "21.10 - Fundidos sem tratamento" },
    { value: 251, label: "21.11 - Laminados com tratamento" },
    { value: 252, label: "21.11 - Laminados sem tratamento" },
    { value: 253, label: "21.12 - Soldas e anodos" },
    { value: 254, label: "21.13 - Relaminação" },
    { value: 255, label: "21.14 - Serviços de tratamento de superfície" },
    { value: 256, label: "21.15 - Siderurgia" },
    { value: 257, label: "21.16 - Tratamento térmico" },
    { value: 258, label: "21.17 - Tratamento de metais" },
    { value: 259, label: "21.18 - Outros" },
  ],
  21: [
    { value: 260, label: "22.01 - Beneficiamento de cloro" },
    { value: 261, label: "22.02 - Fibra sintética" },
    { value: 262, label: "22.03 - Combustíveis não derivados de petróleo" },
    { value: 263, label: "22.04 - Aromáticos" },
    { value: 264, label: "22.05 - Domissanitários" },
    { value: 265, label: "22.06 - Espuma de baixa densidade" },
    { value: 266, label: "22.07 - Fertilizantes e agroquímicos" },
    { value: 267, label: "22.08 - Fios de borracha e látex" },
    { value: 268, label: "22.09 - Pirotécnicos" },
    { value: 269, label: "22.10 - Cosméticos" },
    { value: 270, label: "22.11 - Explosivos" },
    { value: 271, label: "22.12 - Limpeza e polimento" },
    { value: 272, label: "22.13 - Derivados de petróleo" },
    { value: 273, label: "22.14 - Rochas betuminosas" },
    { value: 274, label: "22.15 - Farmacêuticos" },
    { value: 275, label: "22.16 - Químicos para borracha" },
    { value: 276, label: "22.17 - Químicos para calçados" },
    { value: 277, label: "22.18 - Resinas e freios" },
    { value: 278, label: "22.19 - Resinas e fibras" },
    { value: 279, label: "22.20 - Sabão e detergente" },
    { value: 280, label: "22.21 - Velas" },
    { value: 281, label: "22.22 - Solventes e graxas" },
    { value: 282, label: "22.23 - Corantes, tintas em pó" },
    { value: 283, label: "22.24 - Tintas e vernizes" },
    { value: 284, label: "22.25 - Cor para plástico" },
    { value: 285, label: "22.26 - Princípios ativos" },
    { value: 286, label: "22.27 - Extintores" },
    { value: 287, label: "22.28 - Gases" },
    { value: 288, label: "22.29 - Álcool e metanol" },
    { value: 289, label: "22.30 - Óleos, gorduras e ceras" },
    { value: 290, label: "22.31 - Óleos essenciais" },
    { value: 291, label: "22.32 - Substâncias químicas" },
    { value: 292, label: "22.33 - Argamassa" },
    { value: 293, label: "22.34 - CO2" },
    { value: 294, label: "22.35 - Gorduras hidrogenadas" },
    { value: 295, label: "22.36 - Oxigênio" },
    { value: 296, label: "22.37 - Refino de solventes" },
    { value: 297, label: "22.38 - Reembalagem" },
    { value: 298, label: "22.39 - Refinaria" },
    { value: 299, label: "22.40 - Tancagem" },
    { value: 300, label: "22.41 - Outros" },
  ],
  22: [
    { value: 301, label: "23.01 - Beneficiamento de fibras têxteis" },
    { value: 302, label: "23.02 - Confecções" },
    { value: 303, label: "23.03 - Cama, mesa e banho" },
    { value: 304, label: "23.04 - Calçados, cintos e bolsas" },
    { value: 305, label: "23.05 - Entretelas e colarinhos" },
    { value: 306, label: "23.06 - Estofados" },
    { value: 307, label: "23.07 - Componentes têxteis" },
    { value: 308, label: "23.08 - Sandálias e solas" },
    { value: 309, label: "23.09 - Fiação de algodão sem tingimento" },
    { value: 310, label: "23.10 - Fiação e tecelagem sem tingimento" },
    { value: 311, label: "23.11 - Têxtil com tingimento" },
    { value: 312, label: "23.12 - Malharia e tinturaria" },
    { value: 313, label: "23.13 - Acabamentos e vestuários" },
    { value: 314, label: "23.14 - Redes" },
    { value: 315, label: "23.15 - Outros" },
  ],
  23: [
    { value: 316, label: "24.01 - Vidros" },
    { value: 317, label: "24.02 - Artefatos de cimento e concreto" },
    { value: 318, label: "24.03 - Fibra de vidro" },
    { value: 319, label: "24.04 - Colchões" },
    { value: 320, label: "24.05 - Giz escolar" },
    { value: 321, label: "24.06 - Isolantes térmicos" },
    { value: 322, label: "24.07 - Lentes" },
    { value: 323, label: "24.08 - Bijuterias sem banho" },
    { value: 324, label: "24.08 - Bijuterias com banho" },
    { value: 325, label: "24.09 - Gráficas e editoras" },
    { value: 326, label: "24.10 - Emulsões asfálticas" },
    { value: 327, label: "24.11 - Mistura asfáltica" },
    { value: 328, label: "24.12 - Usina de asfalto" },
    { value: 329, label: "24.13 - Usina de concreto" },
    { value: 330, label: "24.14 - Usina de asfalto móvel" },
    { value: 331, label: "24.15 - Outros" },
  ],
  24: [
    { value: 332, label: "25.01 - Reassentamento urbano" },
    { value: 333, label: "25.02 - Equipamentos sociais" },
    { value: 334, label: "25.03 - Projetos urbanísticos" },
    { value: 335, label: "25.04 - Requalificação urbana" },
    { value: 336, label: "25.05 - Balneário" },
    { value: 337, label: "25.06 - Pólo de lazer" },
    { value: 338, label: "25.07 - Equipamentos esportivos" },
    { value: 339, label: "25.08 - Estádio" },
    { value: 340, label: "25.09 - Outros" },
  ],
  25: [
    { value: 341, label: "26.01 - Ferrovias" },
    { value: 342, label: "26.02 - Metrô e VLT" },
    { value: 343, label: "26.03 - Passagem molhada sem barramento" },
    { value: 344, label: "26.03 - Passagem molhada com barramento" },
    { value: 345, label: "26.04 - Pontes e túneis" },
    { value: 346, label: "26.05 - Rodovias - Construção" },
    { value: 347, label: "26.05 - Rodovias - Ampliação" },
    { value: 348, label: "26.06 - Vias - Manutenção" },
    { value: 349, label: "26.07 - Outros" },
  ],
  26: [
    { value: 350, label: "27.01 - ETA Convencional" },
    { value: 351, label: "27.01 - ETA Simplificada" },
    { value: 352, label: "27.02 - Sistema de água sem coagulante" },
    { value: 353, label: "27.02 - Sistema de água com ETA" },
    { value: 354, label: "27.03 - Sistema de esgotamento" },
    { value: 355, label: "27.04 - ETE" },
    { value: 356, label: "27.05 - Estação elevatória" },
    { value: 357, label: "27.06 - Banheiros químicos" },
    { value: 358, label: "27.07 - Outros" },
  ],
  27: [
    { value: 359, label: "28.01 - Estação rádio base" },
    { value: 360, label: "28.02 - Estação repetidora" },
    { value: 361, label: "28.03 - Implantação de sistema de telecomunicações" },
    { value: 362, label: "28.04 - Rede sem infraestrutura" },
    { value: 363, label: "28.05 - Outros" },
  ],
  28: [
    { value: 364, label: "29.01 - Barragens e diques" },
    { value: 365, label: "29.02 - Canais de derivação" },
    { value: 366, label: "29.03 - Sistema adutor" },
    { value: 367, label: "29.04 - Canais de drenagem" },
    { value: 368, label: "29.05 - Dragagem e derrocamento" },
    { value: 369, label: "29.06 - Retificação de corpos hídricos" },
    { value: 370, label: "29.07 - Desassoreamento" },
    { value: 371, label: "29.08 - Outros" },
  ],
  29: [
    { value: 382, label: "31.01 - Criação amadora de passeriformes" },
    { value: 383, label: "31.02 - Zoológico (fauna exótica/silvestre)" },
    { value: 384, label: "31.03 - CETAS" },
    { value: 385, label: "31.04 - CRAS" },
    { value: 386, label: "31.05 - Mantenedor de fauna" },
    { value: 387, label: "31.06 - Criação científica (pesquisa)" },
    { value: 388, label: "31.07 - Criação científica (conservação)" },
    { value: 389, label: "31.08 - Criação comercial de fauna" },
    { value: 390, label: "31.09 - Pet Shop (fauna silvestre)" },
    { value: 391, label: "31.10 - Abatedouro de fauna silvestre" },
    { value: 392, label: "31.11 - Curtume de fauna silvestre" },
    { value: 393, label: "31.12 - Falcoaria" },
    { value: 394, label: "31.13 - ASAS (área de soltura)" },
    { value: 395, label: "31.14 - Manejo (levantamento)" },
    { value: 396, label: "31.15 - Manejo (monitoramento)" },
    { value: 397, label: "31.16 - Manejo (resgate/salvamento)" },
    { value: 398, label: "31.17 - Outros" },
  ],
  30: [
    { value: 372, label: "30.01 - Barracas de praia" },
    { value: 373, label: "30.02 - Complexo turístico e de lazer" },
    { value: 374, label: "30.02 - Complexo turístico (área do projeto)" },
    { value: 375, label: "30.02 - Complexo turístico (unidades habitacionais)" },
    { value: 376, label: "30.03 - Hotéis" },
    { value: 377, label: "30.04 - Pousadas e hospedarias" },
    { value: 378, label: "30.05 - Centros de eventos e convenções" },
    { value: 379, label: "30.06 - Marinas" },
    { value: 380, label: "30.07 - Jardins botânicos" },
    { value: 381, label: "30.08 - Outros" },
  ],
  31: [
    { value: 399, label: "04.01 - AUTORIZAÇÃO PARA USO ALTERNATIVO DO SOLO – AUS" },
    { value: 400, label: "04.02 - AUTORIZAÇÃO DE SUPRESSÃO DE VEGETAÇÃO (ASV)" },
    { value: 401, label: "04.03 - AUTORIZAÇÃO DE USO DO FOGO CONTROLADO" },
    { value: 402, label: "04.04 - AUTORIZAÇÃO DE CORTE DE ÁRVORES ISOLADAS (CAI)" },
    { value: 403, label: "04.05 - AUTORIZAÇÃO PARA EXPLORAÇÃO DE FLORESTA PLANTADA" },
    { value: 404, label: "04.06 - CERTIFICADO DE REPOSIÇÃO FLORESTAL" },
    { value: 405, label: "04.07 - AUTORIZAÇÃO PARA TRANSPLANTIO DE CARNAÚBA E/OU OUTRAS ESPÉCIES" },
    { value: 406, label: "04.08 - AUTORIZAÇÃO PARA UTILIZAÇÃO DE MATÉRIA PRIMA FLORESTAL (AUMPF)" },
  ],
};

// Labels completos (inclui atividades fora do município) para exibição de registros históricos
export const ATIVIDADE_EMPREENDIMENTO_LABELS = Object.fromEntries(
  Object.values(ATIVIDADE_POR_GRUPO_ALL)
    .flat()
    .map((a) => [a.value, a.label])
);

export const ATIVIDADE_POR_GRUPO = filtrarAtividadePorGrupoParaTenant(
  ATIVIDADE_POR_GRUPO_ALL
);

export const GRUPO_ATIVIDADE_OPTIONS = filtrarGruposAtividadeParaTenant(
  GRUPO_ATIVIDADE_OPTIONS_ALL,
  ATIVIDADE_POR_GRUPO
);

export const GRUPO_ATIVIDADE_LABELS = Object.fromEntries(
  GRUPO_ATIVIDADE_OPTIONS_ALL.map((o) => [o.value, o.label])
);

export const GRUPO_ATIVIDADES_FLORESTAIS = 31;
export const GRUPO_ATIVIDADE_FLORESTAL_LABEL = "04 - Atividades Florestais";

export const ATIVIDADES_FLORESTAIS_PROTOCOLO_VALUES = [399, 400, 401, 402, 403, 404, 405, 406];

export const isProtocoloFlorestalEmpreendimento = (empreendimento) => {
  if (!empreendimento) return false;
  const grupo = Number(empreendimento.grupoAtividade);
  const atividade = Number(empreendimento.atividadeEmpreendimento);
  return (
    grupo === GRUPO_ATIVIDADES_FLORESTAIS &&
    ATIVIDADES_FLORESTAIS_PROTOCOLO_VALUES.includes(atividade)
  );
};

export const getAtividadeEmpreendimentoLabel = (value) =>
  ATIVIDADE_EMPREENDIMENTO_LABELS[value] ?? "-";

export const montarEnderecoEmpreendimento = (empreendimento) => {
  if (!empreendimento) return "";
  const end = empreendimento.endereco;
  if (!end) return empreendimento.nome || "";
  const numeroPart = end.numero ? `, ${end.numero}` : "";
  const cep = String(end.cep ?? "").replace(/\D/g, "").padStart(8, "0");
  const estado = (end.estado || "").toUpperCase();
  return `${empreendimento.nome}, ${end.rua || ""}${numeroPart} - CEP: ${cep} - ${end.municipio || ""}-${estado}`;
};

export const PROTOCOLO_STATUS_CRIADO = 0;
export const PROTOCOLO_STATUS_EM_ANDAMENTO = 1;
export const PROTOCOLO_STATUS_EMITIDO = 2;
export const PROTOCOLO_STATUS_AGUARDANDO_APROVACAO = 3;
export const PROTOCOLO_STATUS_APROVADA = 4;

export const protocoloStatusLabels = {
  0: "Criado",
  1: "Em Andamento",
  2: "Emitido",
  3: "Aguardando Aprovação",
  4: "Aprovada",
};

export const protocoloStatusColors = {
  0: "#757575",
  1: "#2196F3",
  2: "#4CAF50",
  3: "#9C27B0",
  4: "#66BB6A",
};

export const tipoAutorizacaoEnum = [
  { value: 0, label: "Uso de Som" },
  { value: 1, label: "Uso do Fogo Controlado" },
];

export const tipoAutorizacaoCodigos = {
  0: "AUS",
  1: "UFC",
};

export function obterCodigoTipoAutorizacao(tipo) {
  const codigo = tipoAutorizacaoCodigos[tipo];
  if (!codigo) throw new Error("Tipo de autorização sem código de processo configurado.");
  return codigo;
}

export const statusAutorizacaoLabels = {
  0: "Aguardando Análise",
  1: "Em Análise",
  2: "Solicitando Informações",
  3: "Aprovada",
  4: "Rejeitada",
  5: "Emitida",
};

export const statusAutorizacaoColors = {
  0: "#F57C00",
  1: "#2196F3",
  2: "#FF9800",
  3: "#4CAF50",
  4: "#F44336",
  5: "#009688",
};

export const statusAutorizacaoEnum = {
  AGUARDANDO_ANALISE: 0,
  EM_ANALISE: 1,
  SOLICITANDO_INFORMACOES: 2,
  APROVADA: 3,
  REJEITADA: 4,
  EMITIDA: 5,
};

export const UNIDADE_MEDIDA_AREA_OPTIONS = [
  { value: 0, label: "ha" },
  { value: 1, label: "m²" },
];

export const statusIsencaoLabels = {
  0: "Solicitado",
  1: "Em Análise",
  2: "Deferido",
  3: "Indeferido",
  4: "Aguardando Pagamento",
  5: "Pagamento Efetuado",
  6: "Aguardando Assinatura",
  7: "Assinada",
};

export const statusIsencaoColors = {
  0: "#9E9E9E",
  1: "#1976D2",
  2: "#2E7D32",
  3: "#C62828",
  4: "#F9A825",
  5: "#00897B",
  6: "#6A1B9A",
  7: "#1B5E20",
};

export const statusIsencaoEnum = {
  SOLICITADO: 0,
  EM_ANALISE: 1,
  DEFERIDO: 2,
  INDEFERIDO: 3,
  AGUARDANDO_PAGAMENTO: 4,
  PAGAMENTO_EFETUADO: 5,
  AGUARDANDO_ASSINATURA: 6,
  ASSINADA: 7,
};

export const statusPublicacaoLabels = {
  0: "Solicitada",
  1: "Aguardando Pagamento",
  2: "Pagamento Efetuado",
  3: "Publicada",
  4: "Recusada",
};

export const statusPublicacaoColors = {
  0: "#9E9E9E",
  1: "#F9A825",
  2: "#00897B",
  3: "#2E7D32",
  4: "#C62828",
};

export const statusPublicacaoEnum = {
  SOLICITADA: 0,
  AGUARDANDO_PAGAMENTO: 1,
  PAGAMENTO_EFETUADO: 2,
  PUBLICADA: 3,
  RECUSADA: 4,
};

export const tipoModeloPublicacaoEnum = {
  PEDIDO_DE_LICENCA: 0,
  RECEBIMENTO_DE_LICENCA: 1,
};

export const tipoModeloPublicacaoLabels = {
  0: "Pedido de licença",
  1: "Recebimento de licença",
};

export const tipoModeloPublicacaoOptions = [
  { value: 0, label: "Pedido de licença" },
  { value: 1, label: "Recebimento de licença" },
];

export const modeloPublicacaoSistemaEnum = {
  REQUERIMENTO_LICENCA_AUTORIZACAO: 1,
  CONCESSAO_LICENCA_AUTORIZACAO: 2,
  CONCESSAO_REGULARIZACAO_LICENCA: 3,
  CONCESSAO_RENOVACAO_LICENCA_AUTORIZACAO: 4,
  REQUERIMENTO_MUDANCA_TITULARIDADE: 6,
  REQUERIMENTO_MUDANCA_TITULARIDADE_PROCESSO_EM_TRAMITE: 7,
  REQUERIMENTO_LICENCA_AUTORIZACAO_AMBIENTAL: 8,
  REQUERIMENTO_RENOVACAO_LICENCA_AUTORIZACAO: 9,
  REQUERIMENTO_REGULARIZACAO_LICENCA: 10,
};

export const modeloPublicacaoSistemaLabels = {
  1: "Requerimento de Licença",
  2: "Concessão de Licença/Autorização Ambiental",
  3: "Concessão de Regularização de Licença Ambiental",
  4: "Concessão de Renovação de Licença/Autorização Ambiental",
  6: "Requerimento de Licença/Autorização Ambiental com Mudança de Titularidade",
  7: "Requerimento de Mudança de Titularidade com Processo em Trâmite",
  8: "Requerimento de Licença/Autorização Ambiental",
  9: "Requerimento para Renovação de Licença/Autorização Ambiental",
  10: "Requerimento para Regularização de Licença Ambiental",
};

export const categoriasRequerimentoMudancaTitularidade = [
  "Renovação",
  "Regularização",
  "Autorização ambiental",
];

export const tipoPublicacaoEnum = {
  PEDIDO_DE_LICENCA: 0,
  RECEBIMENTO_DE_LICENCA: 1,
};

export const tipoPublicacaoLabels = {
  0: "Pedido de licença",
  1: "Recebimento de licença",
};

export const DOCUMENTO_COMPROVANTE_PUBLICACAO_PEDIDO =
  "Comprovante de Publicação de Pedido de Licença";

export const CHAR_LIMITS = {
  nomeOuRazaoSocial: 200,
  textoTipoLicenca: 500,
  atividadePublicacao: 500,
  enderecoPublicacao: 500,
  numeroProcessoEmTramite: 50,
  atividadeELocal: 1000,
};
